import { render } from "./source-whereabouts.vue?vue&type=template&id=23b1bda0&scoped=true"
import script from "./source-whereabouts.vue?vue&type=script&lang=js"
export * from "./source-whereabouts.vue?vue&type=script&lang=js"

import "./source-whereabouts.vue?vue&type=style&index=0&id=23b1bda0&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b1bda0"]])

export default __exports__